// src/components/StoreDropdown.jsx
import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useTranslation } from 'react-i18next';

const StoreDropdown = ({
  lists = [],
  activeList,
  onListChange,
  onNewListClick,
  className = ''
}) => {
  const { t } = useTranslation();
  const activeListName = activeList?.name || t('list.noList');
  const activeListCount = activeList?.item_count || 0;
  const activeListLabel = activeList ? `${activeListName} (${activeListCount})` : activeListName;

  return (
    <Menu as="div" className={`relative inline-block text-left text-sm ${className}`}>
      <Menu.Button className="pt-1 pb-1 inline-flex items-center text-gray-800 hover:text-gray-900 focus:outline-none">
        <span className="font-medium">{t('list.label')}</span>
        <span className="ml-1 font-bold">{activeListLabel}</span>
        <i className="fas fa-caret-down ml-1 text-xs text-gray-500"></i>
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-1 w-48 origin-top-right bg-white rounded-md shadow-lg border border-gray-200 z-50">
          <div className="py-1">
            {lists.map((list) => (
              <Menu.Item key={list.id}>
                {({ active }) => (
                  <button
                    onClick={() => onListChange(list)}
                    className={`w-full text-left px-3 py-2 text-sm ${
                      active ? 'bg-gray-50' : 'text-gray-700'
                    } ${activeList?.id === list.id ? 'text-purple-600 font-medium' : ''}`}
                  >
                    <span>{list.name}</span>
                    <span className="ml-1 text-gray-400">({list.item_count || 0})</span>
                  </button>
                )}
              </Menu.Item>
            ))}

            <div className="border-t border-gray-200 my-1"></div>

            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={onNewListClick}
                  className={`w-full text-left px-3 py-2 text-sm ${
                    active ? 'bg-gray-50' : 'text-gray-700'
                  } text-purple-600 font-medium flex items-center`}
                >
                  <i className="fas fa-plus mr-2 text-xs"></i>
                  {t('list.newList')}
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default StoreDropdown;
